import { InfoCard } from "../common/InfoCard"
import { LabelRow } from "../common/LabelRow"
import { PropertySetSelect } from "../common/PropertySetSelect"
import { ManualInputRow } from "../common/ManualInputRow"
import { StreamName } from "../common/StreamName"
import { UnitImageWithStatus } from "../common/UnitImageWithStatus"
import { NozzleTableWarp } from "../common/NozzleTable/NozzleTableWarp"
import { UnitProps } from "../unitTypes"
const spliterSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="328" height="122" viewBox="0 0 328 122" fill="none">
<path d="M110 61L100 55.2265V66.7735L110 61ZM0 62H101V60H0V62Z" fill="#319800"/>
<g clip-path="url(#clip0_882_59449)">
<path class="unit-path" d="M216 12L216 110L169.618 110L113.055 61L169.618 12L216 12Z" stroke="black" stroke-width="4"/>
</g>
<path d="M328 31L318 25.2265V36.7735L328 31ZM218 32H319V30H218V32Z" fill="#319800"/>
<path d="M328 91L318 85.2265V96.7735L328 91ZM218 92H319V90H218V92Z" fill="#319800"/>
<defs>
<clipPath id="clip0_882_59449">
<rect width="108" height="122" fill="white" transform="translate(110)"/>
</clipPath>
</defs>
</svg>
`

interface StreamSplitterProps extends UnitProps {

}

export const StreamSplitter = (props: StreamSplitterProps) => {
  const {unit, data, reload} = props
  const inData = data?.vars?.IN || {} as any

  const nozzles = unit.nozzles
    .filter(item => item.name.startsWith('OUT') && data?.vars?.[item.name])
    .map((item) => {
      const outData = data?.vars?.[item.name] || {} as any
      const index = item.name.match(/^OUT(\d+)$/)?.[1]!
      return {
        index: Number(index),
        unitId: outData.unitId,
        eta: outData.ETA,
        flow: outData.F,
        key: `:${item.name}:ETA`
      }
    })

  return <div>
    <UnitImageWithStatus svg={spliterSvg} data={data} height={80}/>
    <div className="mt-1">
      <InfoCard title="Inlet:">
        <LabelRow label="Stream" value={<StreamName unitId={inData.unitId}/>}/>
        <ManualInputRow label="Flow" data={inData.F} dimCode='MOL_F' attrKey=":IN:F" unitId={unit.id} reload={reload}/>
      </InfoCard>

      {/* <InfoCard title="Outlet:" className="mt-1">
        
        <NozzleTable data={nozzles} onChange={(key, val) => onChange(key, val)}/>
      </InfoCard> */}

      <NozzleTableWarp reload={reload}  className="mt-1" data={nozzles} title="Outlets:" unit={unit}/>
      
      <PropertySetSelect unitId={unit.id} value={data?.args?.tpps} />
    </div>
  </div>
}